import { apiGet } from './client';

export interface ConsolePermissionCatalogItem {
  codename: string;
  name: string;
}

export async function list(): Promise<{ permissions: ConsolePermissionCatalogItem[] }> {
  return apiGet('/permissions/');
}
